import { render, staticRenderFns } from "./MarqueForm.vue?vue&type=template&id=80ecd194&"
import script from "./MarqueForm.vue?vue&type=script&lang=js&"
export * from "./MarqueForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports